import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardContent, Chip, Stack, Typography } from '@material-ui/core';
import { useQuery, gql } from '@apollo/client';

// Its own query on purpose: EditEshopForm sends everything its getEshop loaded back through
// updateEshop, so selecting languageIds there would write them on every save — and a
// languageIds change makes the eshop-router redeploy the snippet. Read-only here.
const GET_ESHOP_LANGUAGES = gql`
  query getEshopLanguages($id: ID!) {
    getEshop(id: $id) {
      id
      languageIds
    }
  }
`;

function EshopLanguages({ id }) {
  const { t } = useTranslation();
  const { data } = useQuery(GET_ESHOP_LANGUAGES, { variables: { id } });

  const languages = data?.getEshop?.languageIds?.filter(Boolean) || [];
  if (languages.length === 0) {
    return null;
  }

  return (
    <Card sx={{ mt: 3 }}>
      <CardHeader title={t('settings.languages')} />
      <CardContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          {t('settings.languages_description')}
        </Typography>
        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
          {languages.map((lang) => (
            <Chip key={lang} label={lang} variant="outlined" />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

EshopLanguages.propTypes = {
  id: PropTypes.string.isRequired
};

export default EshopLanguages;
